import type { TabId } from "../types/tab-id.ts";
import { getPluralisedArrayTitle } from "../../../utils/arrays-helper.ts";
import type ResponsiveImage from "../../../components/responsive-image/responsive-image.ts";

export interface PropertyDetailsTabMeta {
  id: TabId;
  label: string;
  icon: string;
}

export const getPropertyDetailsTabsMeta = (images: ResponsiveImage[]): Record<string, PropertyDetailsTabMeta> => ({
  photos: {
    id: "photos",
    label: getPluralisedArrayTitle("photo", "photos", images),
    icon: "images",
  },
  virtualTour: {
    id: "virtual-tour",
    label: "Virtual tour",
    icon: "360-degrees",
  },
  video: {
    id: "video",
    label: "Video",
    icon: "video",
  },
  floorPlan: {
    id: "floor-plan",
    label: "Floor plan",
    icon: "ruler-combined",
  },
  map: {
    id: "map",
    label: "Map",
    icon: "map-location-dot",
  },
  streetView: {
    id: "street-view",
    label: "Street view",
    icon: "street-view",
  },
});
